import React from 'react';
import { Layout, Button } from "antd";
import { withRouter } from 'react-router-dom';
import './VetsmithNavigationDrawer.scss';
import TuringLogoText from "../../assets/img/turing_logo_text.svg";
import { PageConstant } from '../../constants';
import DrawerActions from '../../actions/Drawer';
import { connect } from 'react-redux';

const { Header } = Layout;

const VetsmithNavigationDrawer = ({ history, exitVetsmith }) => (
    <Header
        id="VetsmithNavDrawer"
        data-testid="nav-drawer"
        collapsedWidth="0"
        hasSider={false}
    >
        <div id="title">
            <img
                id="turing_logo"
                data-testid="turing_logo"
                src={TuringLogoText}
                alt="Turing"
                style={{ width: "65px", height: "auto" }}
            />
        </div>
        <Button className="exit-vetsmith"  type="link" onClick={() => {
            exitVetsmith(true)
        }}>Go back to the Talent Portal</Button>
    </Header>
)


const mapDispatchToProps = (dispatch) => {
    return {
      dispatch,
      exitVetsmith: payload => dispatch(DrawerActions.exitVetsmith(payload)),
    };
  };


export default connect(null, mapDispatchToProps)(VetsmithNavigationDrawer);